import { render } from "./PaperIcon.vue?vue&type=template&id=58abc723"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/PaperIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58abc723"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58abc723', __exports__)) {
    api.reload('58abc723', __exports__)
  }
  
  module.hot.accept("./PaperIcon.vue?vue&type=template&id=58abc723", () => {
    api.rerender('58abc723', render)
  })

}


export default __exports__